import React from "react";

export default function SplitSection({
  title,
  highlight,
  extratitle,
  subTitle,
  quote,
  descriptions = [],
  features = [],
  blockInfo,
  buttonText,
  onButtonClick,
  gradientBackground,
  image,
  imagePosition = "left", // "left" | "right"
  bgColor = "#fff",
  textColor = "#000",
  btnImg,
  extraOptions  
}) {
  const isImageLeft = imagePosition === "left";

  return (
    <section
      className={`split-section py-5 mt-5 ${gradientBackground ? 'split-section-second' : ''}`}
      style={{ '--background-color': bgColor, '--text-color': textColor }}
    >
      <div className="custom-container">
        <div className="row align-items-center justify-content-between">
          {/* IMAGE */}
          <div
            className={`col-lg-6 mb-4 mb-lg-0 ${
              isImageLeft ? "" : "order-lg-2"
            }`}
          >
            <div className="text-center">
              <img src={image} alt="section" className="img-fluid" />
            </div>
          </div>

          {/* CONTENT */}
          <div className={`col-lg-6 ${isImageLeft ? "" : "order-lg-1"}`}>
            <div className="content-wrapper">
              {/* TITLE */}
              <h3 className="hero-title FS40FW600 mb-4">
                {title} 
                {highlight && (
                  <span className="text-success FS40FW600">{" "}{highlight}</span>
                )}
                {subTitle && (subTitle)}
              </h3>

              {extratitle && (
                <div>{extratitle()}</div>
              )}

              {/* QUOTE */}
              {quote && (
                <div className="quote-box FS18FW400 mb-4">
                  <p>{quote}</p>
                </div>
              )}

              {/* DESCRIPTION */}
              {descriptions.map((desc, i) => (
                <p className="desc" key={i}>
                  {desc}
                </p>
              ))}

              {/* LIST */}
              {/* {features.length > 0 && (
                <div className={`${features[0].desc ? 'feature-grid' : ''}`}>
                  <ul className="feature-list">
                    {features.map((item, i) => (
                      (item.desc ? 
                        ( <div className="feature-item plus-sans" key={i}>
                            <li className="fw-700 FS18FW400">{item.title}</li>
                            <span className="FS16FW500 fw-400" >{item.desc}</span>
                          </div>
                        ) : ( <li key={i}>{item}</li> )  )
                      
                    ))}
                  </ul>
                </div>
              )} */}
              {features.length > 0 && (
                <ul
                  className={`feature-list ${
                    features[0]?.desc ? "feature-grid" : ""
                  }`}
                >
                  {features.map((item, i) => (
                    <li
                      key={i}
                      className={`feature-item plus-sans ${
                        features.length % 2 !== 0 &&
                        i === features.length - 1
                          ? "full-width"
                          : ""
                      }`}
                    >
                      {item.desc ? (
                        <div>
                          <h6 className="fw-700 FS18FW400 mb-2 to-unset-transform">
                            {item.title}
                          </h6>

                          <span className="FS16FW500 fw-400">
                            {item.desc}
                          </span>
                        </div>
                      ) : (
                        item
                      )}
                    </li>
                  ))}
                </ul>
              )}

              {blockInfo &&                
                  <div>
                    {blockInfo()}
                  </div>
                }

              {/* BUTTON */}
              {buttonText && (
                <div className="btn-wrapper pt-5">
                  <button className="primary-btn" onClick={onButtonClick}>
                    {buttonText}
                    <img
                      src={btnImg || "/images/web-new-images/new-dark-arrow.svg"}
                      alt="arrow"
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {extraOptions && (
        <div className=" py-5">
          <div className="container">
            <div className="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-4 justify-content-center">
              {Array.isArray(extraOptions) ? (
                extraOptions.map((option, index) => (
                  <div key={index} className="col">
                    <div className="d-flex align-items-center gap-2">
                      <div className="check-icon-wrapper">
                        <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 7.5L6 12.5L17 1.5" stroke="#94C23C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                      <span className="FS16FW500 text-nowrap" style={{ color: textColor }}>{option}</span>
                    </div>
                  </div>
                ))
              ) : (
                typeof extraOptions === "function" ? extraOptions() : extraOptions
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
